import { redirect } from "@tanstack/react-router";
import {
	type AdminAccess,
	hasAdminFeature,
	loadAdminAccess,
} from "@/utils/admin-access";
import type { AdminMenuFeatureKey } from "@/utils/permission.features";

/**
 * Guard `beforeLoad` per halaman panel admin: menolak membuka route bila fitur
 * menunya belum diizinkan, bukan hanya menyembunyikan item sidebar. Dialihkan ke
 * Beranda panel admin (`/admin`) yang sengaja tanpa kunci fitur, jadi tidak ada
 * risiko alihan berputar.
 *
 * Ini tetap lapis kenyamanan — lapis yang menentukan adalah guard endpoint di
 * `./admin-feature`, yang menolak walau route klien dilewati.
 */
export function requireAdminFeature(feature: AdminMenuFeatureKey) {
	return async (): Promise<{ adminAccess: AdminAccess }> => {
		const adminAccess = await loadAdminAccess();
		if (!hasAdminFeature(adminAccess, feature)) {
			throw redirect({ to: "/admin", replace: true });
		}
		return { adminAccess };
	};
}
